import { useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as LogoutIcon } from '../../../../../../assets/icons/logout.svg';
import { ISidebarUserProfileProps } from '../../../../../interfaces/globals';
import { TRANSLATIONS_GLOBAL } from '../../../../../translations/commons';
import DropdownMenu from '../../../DropdownMenu/DropdownMenu';

const SidebarUserProfile = ({ initials, displayName, role, collapsed, onProfileClick }: ISidebarUserProfileProps) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return;
    const handleOutsideClick = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [open]);

  const menuItems = [
    {
      key: 'logout',
      label: t(TRANSLATIONS_GLOBAL.logout),
      icon: <LogoutIcon />,
      onClick: () => {
        setOpen(false);
        onProfileClick();
      }
    }
  ];

  return (
    <div className="sidebar__footer" ref={containerRef}>
      <button
        type="button"
        className="sidebar-user"
        aria-label={`${displayName} · ${role}`}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        <div className="sidebar-user__avatar">{initials}</div>
        {!collapsed && (
          <div className="sidebar-user__info">
            <span className="sidebar-user__name">{displayName}</span>
            <span className="sidebar-user__role">{role}</span>
          </div>
        )}
      </button>
      {open && <DropdownMenu items={menuItems} placement="right" />}
    </div>
  );
};

export default SidebarUserProfile;
